import { z } from 'zod';

export const emailSchema = z
  .string()
  .email('Endereço de email inválido')
  .max(255, 'Email demasiado longo');

export const passwordSchema = z
  .string()
  .min(8, 'A palavra-passe deve ter pelo menos 8 caracteres')
  .max(200, 'Palavra-passe demasiado longa');

export const phoneSchema = z
  .string()
  .regex(/^(\+351)?\s?9\d{8}$/, 'Número de telemóvel português inválido')
  .optional()
  .or(z.literal(''));

export const nifSchema = z
  .string()
  .regex(/^\d{9}$/, 'NIF inválido (9 dígitos)')
  .optional()
  .or(z.literal(''));

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  firstName: z.string().min(1, 'Nome obrigatório').max(100),
  lastName: z.string().min(1, 'Apelido obrigatório').max(100),
  phone: phoneSchema,
  nif: nifSchema,
  acceptTerms: z.literal(true, {
    errorMap: () => ({ message: 'Deve aceitar os termos e condições' }),
  }),
});

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Palavra-passe obrigatória'),
});

export const forgotPasswordSchema = z.object({
  email: emailSchema,
});

export const resetPasswordSchema = z.object({
  token: z.string().min(10, 'Token inválido'),
  password: passwordSchema,
});

export const verifyEmailSchema = z.object({
  token: z.string().min(10, 'Token inválido'),
});

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, 'Palavra-passe atual obrigatória'),
  newPassword: passwordSchema,
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
export type VerifyEmailInput = z.infer<typeof verifyEmailSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
